import * as Sentry from "@sentry/browser";
import { BrowserTracing } from "@sentry/tracing";

import "./jquery-global";
import "jquery-ui/dist/jquery-ui";
import "jquery-ui-touch-punch";
import "bootstrap";
import "select2";
import "timepicker";
import "tablesorter";
import "tablesorter/dist/js/parsers/parser-date-range.min";

import _ from "underscore";
import Backbone from "backbone";
import linkifyJq from "linkifyjs/jquery";
import autosize from "autosize";

import AlertBar from "./alertbar";
import { AlertView, BasicDialog } from "./alerts";
import Pagination from "./pagination";
import HeaderMessages from "./messages";
import Utils from "./utils";
import Base from "./base";
import FileServiceHelpers from "./file-service-helpers";
import Common from "./common";
import Schedule from "./schedule";
import QuickMenu from "./quick-menu";
import { LessonCard } from "./dialog.lesson";
import { MessageDialog } from "./dialog.messages";
import { RadioPlugin, Radiocheck } from "./radiocheck";
import "./dateExtensions";

const sentry = JSON.parse(
  document.getElementById("sentry")?.textContent || null
);

if (sentry) {
  Sentry.init({
    dsn: sentry.dsn,
    environment: sentry.environment,
    integrations: [new BrowserTracing()],
    initialScope: { user: S.session.user },
  });
}

window._ = _;

linkifyJq($, document);

Backbone.$ = $;
Backbone._ = _;
window.Backbone = Backbone;

Backbone.emulateHTTP = true;
var _sync = Backbone.sync;
Backbone.sync = function (method, model, options) {
  options.beforeSend = function (xhr) {
    xhr.setRequestHeader("X-CSRFToken", csrf_token);
  };
  return _sync(method, model, options);
};

window.AlertBar = AlertBar;
window.AlertView = AlertView;
window.Base = Base;
window.BasicDialog = BasicDialog;
window.Common = Common;
window.FileServiceHelpers = FileServiceHelpers;
window.LessonCard = LessonCard;
window.MessageDialog = MessageDialog;
window.Pagination = Pagination;
window.Schedule = Schedule;
window.Utils = Utils;
window.S = { ...(window.S || {}) };

$.extend($.fn.select2.defaults, { minimumResultsForSearch: 8 });

// https://getbootstrap.com/docs/3.4/javascript/#js-sanitizer
$.fn.tooltip.Constructor.DEFAULTS.whiteList["*"].push("style", "data-id");
$.fn.popover.Constructor.DEFAULTS.whiteList["*"].push("style", "data-id");

$.fn.timepicker.defaults["timeFormat"] = "G:i";

$.fn.radiocheck = RadioPlugin;
$.fn.radiocheck.Constructor = Radiocheck;

$.fn.quickMenu = function (options) {
  this.each(function () {
    var $this = $(this);
    if ($this.data("quickMenu")) {
      $this.data("quickMenu").update(options);
    } else {
      var quickMenu = new QuickMenu($.extend({ el: this }, options));
      $this.data("quickMenu", quickMenu);
    }
    return $this;
  });
};

$.fn.enableMessageLink = function () {
  return this.off().on("click", function (e) {
    e.preventDefault();
    var $bn = $(e.currentTarget);
    var data = {};

    if ($bn.attr("data-user-id") && $bn.attr("data-user-name")) {
      data = {
        user_id: $bn.attr("data-user-id"),
        full_name: $bn.attr("data-user-name"),
      };
    }

    if ($bn.attr("data-title")) {
      data["title"] = $bn.attr("data-title");
    }

    new MessageDialog(data);
  });
};

$.basicPost = function (url, data, successCallback, errorCallback) {
  return $.post(
    url,
    _.extend(
      {
        csrfmiddlewaretoken: csrf_token,
      },
      data
    ),
    function (response) {
      if (response && response.status === 200) {
        successCallback(response.data);
      } else if (errorCallback) {
        errorCallback(response.error);
      } else {
        AlertBar.showErrorMessage(response.error);
      }
    }
  ).fail(function (jqXHR) {
    var error =
      (jqXHR.responseJSON && jqXHR.responseJSON.error
        ? jqXHR.responseJSON.error
        : jqXHR.responseText) || false;
    if (error && error.length > 100) {
      error = "Ett oväntat fel inträffade";
    }
    if (errorCallback) {
      errorCallback(error);
    } else {
      AlertBar.showErrorMessage(error);
    }
  });
};

$.basicGet = function (url, data, successCallback, errorCallback) {
  if (url.indexOf("format") === -1) {
    url = url.indexOf("?") === -1 ? url + "?format=json" : url + "&format=json";
  }
  return $.get(url, data, function (response) {
    if (response && response.status === 200) {
      successCallback(response.data);
    } else if (errorCallback) {
      errorCallback(response.error);
    } else {
      AlertBar.showErrorMessage(response.error);
    }
  }).fail(function (jqXHR) {
    var error =
      (jqXHR.responseJSON && jqXHR.responseJSON.error
        ? jqXHR.responseJSON.error
        : jqXHR.responseText) || false;
    if (error && error.length > 100) {
      error = "Ett oväntat fel inträffade";
    }
    if (errorCallback) {
      errorCallback(error);
    } else {
      AlertBar.showErrorMessage(error);
    }
  });
};

Array.prototype.remove = function (item) {
  var index = $.inArray(item, this);
  if (index != -1) {
    this.splice(index, 1);
  }
  return this;
};

$(function () {
  if (S.session && S.session.user && S.session.user.sp_account) {
    var lang = S.session.user.sp_account.language.substr(0, 2);
    if (lang == "en") {
      $.extend($.fn.select2.defaults, $.fn.select2.locales[lang]);
    }
  }

  $('[data-toggle="select"]').select2({ minimumResultsForSearch: 8 });
  Base.setupFlexSelects($('[data-toggle="flex-select"]'));

  // Checkboxes and Radiobuttons
  $('[data-toggle="checkbox"]').radiocheck();
  $('[data-toggle="radio"]').radiocheck();

  // Timepicker
  $('[data-toggle="timepicker"]')
    .timepicker()
    .next(".input-group-btn")
    .on("click", function (e) {
      e && e.preventDefault();
      $(e.currentTarget).siblings("input").focus();
    });

  // Datepicker
  $.datepicker.regional["sv"] = {
    closeText: "Stäng",
    prevText: "Föregående",
    nextText: "Nästa",
    currentText: "Nu",
    monthNames: [
      "Januari",
      "Februari",
      "Mars",
      "April",
      "Maj",
      "Juni",
      "Juli",
      "Augusti",
      "September",
      "Oktober",
      "November",
      "December",
    ],
    monthNamesShort: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "Maj",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Okt",
      "Nov",
      "Dec",
    ],
    dayNamesShort: ["Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör"],
    dayNames: [
      "Söndag",
      "Måndag",
      "Tisdag",
      "Onsdag",
      "Torsdag",
      "Fredag",
      "Lördag",
    ],
    dayNamesMin: ["Sö", "Må", "Ti", "On", "To", "Fr", "Lö"],
    weekHeader: "He",
    dateFormat: "yyyy-mm-dd",
    firstDay: 1,
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: "",
  };
  $.datepicker.setDefaults(
    $.datepicker.regional[S.session?.user?.sp_account?.language || "sv"] ||
      $.datepicker.regional["sv"]
  );
  $.extend($.datepicker, {
    _checkOffset: function (inst, offset) {
      return offset;
    },
  });
  Base.setupDatepicker($('[data-toggle="datepicker"]'));

  // Table sorter
  if ($.tablesorter && $("table.tablesorter").length) {
    $("table.tablesorter").each(function () {
      var $tbl = $(this);
      var data = {
        headers: {},
      };
      if ($tbl.attr("data-sort-list")) {
        data.sortList = JSON.parse($tbl.attr("data-sort-list"));
      }
      $tbl.find('th[data-sorter="false"]').each(function () {
        data.headers[$(this).index()] = { sorter: false };
      });
      if ($tbl.find(":not(thead) tr").size() > 1) {
        $tbl.tablesorter(data);
      }
    });
  }

  // Tabs
  $(".nav-tabs a").on("click", function (e) {
    e.preventDefault();
    $(this).tab("show");
  });

  // Tooltips
  $('[data-toggle="tooltip"]').tooltip();

  // Popovers
  $('[data-toggle="popover"]').popover();

  // Remove messages
  if ($(".alertbar").length) {
    $(".alertbar")
      .delay(2000)
      .animate(
        {
          top: "-80px",
        },
        500,
        function () {
          $(this).remove();
        }
      );
  }

  // Focus state for append/prepend inputs
  $(".input-group")
    .on("focus", ".form-control", function () {
      $(this).closest(".input-group, .form-group").addClass("focus");
    })
    .on("blur", ".form-control", function () {
      $(this).closest(".input-group, .form-group").removeClass("focus");
    });

  // Automatically link all elems with data-href tag
  $("[data-href]").on("click", function (e) {
    if (
      $(this).attr("data-href-skip-class") &&
      $(e.target).hasClass($(this).attr("data-href-skip-class"))
    ) {
      return;
    }
    e.preventDefault();
    Base.goTo($(this).attr("data-href"));
  });

  $('[data-toggle="show"]').on("click", function () {
    var _this = $(this);
    if (_this.attr("data-target")) {
      $(_this.attr("data-target")).toggleClass("hide");
    }
  });

  $('[data-toggle="activate"]').on("click", function () {
    var _this = $(this);
    if (_this.attr("data-target")) {
      $(_this.attr("data-target")).toggleClass("active");
    }
  });

  // Setup disable buttons
  $("[data-action='disable']").on("click", function () {
    $(this).addClass("disabled");
  });

  $(document).on("submit", "form.confirm-form", function (e) {
    var $form = $(this);
    if ($form.data("confirmed")) {
      return true;
    }

    e.stopPropagation();
    e.preventDefault();
    var title = $(this).attr("data-confirm-title") || "Bekräfta";
    var txt = "Vill du verkligen göra detta?";
    if ($(this).attr("data-confirm-full-text")) {
      txt = $(this).attr("data-confirm-full-text");
    } else if ($(this).attr("data-confirm-text")) {
      txt = "Vill du verkligen " + $(this).attr("data-confirm-text") + "?";
    }
    // return confirm(txt);
    AlertView.confirmObject({
      title: title,
      message: txt,
      callback: function () {
        $form.data("confirmed", true);
        $form
          .find("button[type='submit']")
          .addClass("disabled")
          .attr("disabled", "disabled");
        $form.submit();
      },
    });

    return false;
  });

  // Setup foldable submenus
  $(".btn-fold").on("click", function (e) {
    e.preventDefault();
    var $sidebar = $(this).closest(".sidebar");
    if ($sidebar.data("open")) {
      $sidebar.data("open", false).removeClass("open");
      $sidebar
        .find(".btn-fold i")
        .removeClass("fui-cross")
        .addClass("fui-list");
    } else {
      $sidebar.data("open", true).addClass("open");
      $sidebar
        .find(".btn-fold i")
        .removeClass("fui-list")
        .addClass("fui-cross");
    }
  });

  // Setup message dialog links
  $('[data-toggle="message-dialog"]').enableMessageLink();

  // Resize textareas automatically, based on content height
  autosize($(".auto-height"));

  function setTopPadding() {
    $(".main-row").css(
      "padding-top",
      $("#main-header #sub-menu").height() + 56
    );
  }
  setTopPadding();
  setTimeout(setTopPadding, 100);
  $(window).on("resize", _.throttle(setTopPadding, 100));

  if ($("#header-messages").size()) {
    window.HeaderMessages = new HeaderMessages();
  }
});
